import React from 'react';
import PropTypes from 'prop-types';

// FormFeedback custom (from scratch) — remplace le FormFeedback de reactstrap.
// Rend un <div class="invalid-feedback"> (ou valid-feedback / *-tooltip).
const FormFeedback = ({ className, valid, tooltip, tag: Tag = 'div', children, ...attributes }) => {
  const validMode = tooltip ? 'tooltip' : 'feedback';
  const classes = [valid ? `valid-${validMode}` : `invalid-${validMode}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...attributes}>
      {children}
    </Tag>
  );
};

FormFeedback.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  valid: PropTypes.bool,
  tooltip: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default FormFeedback;
